export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الأمان"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الخروج"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الشركات"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الإدارة"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حساب الشركة"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حسابات DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التطوير"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تقرير الترجمة"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعليمات الاستخدام"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإفصاح القانوني"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حماية البيانات"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاختصاص - اللغة"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد شركة معينة. الرجاء إضافة شركة."])}
          }
        }
      },
      "ar-EG": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الأمان"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الخروج"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الشركات"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الإدارة"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حساب الشركة"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حسابات DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التطوير"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تقرير الترجمة"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعليمات الاستخدام"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإفصاح القانوني"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حماية البيانات"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد شركة معينة. الرجاء إضافة شركة."])}
          }
        }
      },
      "ar-SA": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الأمان"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الخروج"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب الشركات"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الإدارة"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حساب الشركة"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حسابات DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التطوير"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تقرير الترجمة"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعليمات الاستخدام"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإفصاح القانوني"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حماية البيانات"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد شركة معينة. الرجاء إضافة شركة."])}
          }
        }
      },
      "de-DE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwaltungseinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontenverwaltung"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklungseinstellungen"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiktion - Sprache"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        }
      },
      "de-AT": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwaltungseinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontenverwaltung"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklungseinstellungen"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiktion - Sprache"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        }
      },
      "de-CH": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskonto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwaltungseinstellungen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontenverwaltung"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklungseinstellungen"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impressum"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutz"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiktion - Sprache"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        }
      },
      "en-US": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account Settings"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security Settings"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Account"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Settings"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration Settings"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Accounts Administration"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Accounts Administration"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Development Settings"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound message"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal Disclosure"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Protection"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiction - Language"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No assigned company. Please add a company"])}
          }
        }
      },
      "en-GB": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account Settings"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security Settings"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Account"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Settings"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration Settings"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Accounts Administration"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Accounts Administration"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Development Settings"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal Disclosure"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Protection"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiction - Language"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No assigned company. Please add a company"])}
          }
        }
      },
      "it-IT": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni dell'Account DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conto DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di Sicurezza"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di integrazione"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account Aziendale"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni Azienda"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di amministrazione"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione dell'account aziendale"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione dei conti DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di sviluppo"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaggi in uscita"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapporto di traduzione"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condizioni d'uso"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgazione legale"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protezione Dati"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Competenza - Lingua"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessuna azienda assegnata. Aggiungi un'azienda."])}
          }
        }
      },
      "fr-FR": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les Paramètres de Sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'Entreprise"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'administration"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration des comptes DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de développement"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgation légale"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des Données"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiction - Langue"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        }
      },
      "es-ES": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Cuenta DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de Seguridad"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar sesión"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de integración"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuenta Corporativa"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Empresa"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de administración"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de cuentas de empresa"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de cuentas DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de desarrollo"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensajes salientes"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informe de traducción"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Términos de Uso"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgación legal"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protección de Datos"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdicción - Idioma"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sin empresa asignada. Añade una empresa."])}
          }
        }
      },
      "pl-PL": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Konta DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Bezpieczeństwa"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyloguj"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia integracji"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto Firmowe"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Firmy"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia administracyjne"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zarządzanie kontem firmowym"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracja kontami DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia rozwoju"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomości wychodzące"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport z tłumaczenia"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warunki korzystania"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ujawnienie prawne"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrona Danych"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurysdykcja - Język"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak przypisanej firmy. Dodaj firmę."])}
          }
        }
      },
      "nl-NL": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Accountinstellingen"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Account"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beveiligingsinstellingen"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afmelden"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integratie-instellingen"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zakelijke Rekening"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinstellingen"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beheer instellingen"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsaccount administratie"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratie van DutyPay-rekeningen"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontwikkelingsinstellingen"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uitgaande berichten"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertaalrapport"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruiksvoorwaarden"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wettelijke openbaarmaking"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gegevensbescherming"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevoegdheid - Taal"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen toegewezen bedrijf. Voeg een bedrijf toe."])}
          }
        }
      },
      "bg-BG": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на DutyPay Aкаунт"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Сметка"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на Cигурността"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Излизане от профила"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за интеграция"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Корпоративна Cметка"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на Kомпанията"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Административни настройки"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация на фирмена сметка"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администриране на сметки в DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за разработка"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изходящи съобщения"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доклад за превода"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия за ползване"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Правно разкриване"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Защита на Данни"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Юрисдикция - Език"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма определена компания. Моля, добавете фирма."])}
          }
        }
      },
      "bs-BA": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke DutyPay Računa"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Račun"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne Postavke"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjavite se"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporativni Račun"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Kompanije"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administracije"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa kompanije"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay administracija računa"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke razvoja"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prevođenju"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravila korištenja"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravna objava"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaštita Podataka"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nadležnost - Jezik"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema dodijeljene kompanije. Molimo dodajte kompaniju."])}
          }
        }
      },
      "da-DK": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoindstillinger"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikkerhedsindstillinger"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log ud"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsindstillinger"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedskonto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsindstillinger"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrationsindstillinger"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration af virksomhedskonto"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account Administration"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udviklingsindstillinger"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udgående beskeder"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oversættelsesrapport"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betingelser for brug"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridisk oplysning"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Beskyttelse"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdiktion - Sprog"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intet tildelt firma. Tilføj venligst et firma."])}
          }
        }
      },
      "et-EE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konto Seaded"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvaseaded"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logi välja"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integreerimise seaded"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte Konto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte Seaded"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haldusseaded"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte konto haldamine"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay kontode administreerimine"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arendusseaded"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Väljaminevad sõnumid"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tõlkearuanne"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutustingimused"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juriidiline avalikustamine"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andmekaitse"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kohtualluvus - Keel"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Määratud ettevõtet pole. Palun lisage ettevõte."])}
          }
        }
      },
      "fi-FI": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Tilin Asetukset"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Tili"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvallisuusasetukset"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirjaudu ulos"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrointiasetukset"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritystili"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen Asetukset"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hallinta-asetukset"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritystilin hallinta"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-tilien hallinta"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kehitysasetukset"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtevät viestit"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käännösraportti"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritys"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttöehdot"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lailliset tiedot"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datan Suojelu"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toimivalta - Kieli"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei nimettyä yritystä. Lisää yritys."])}
          }
        }
      },
      "el-GR": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Λογαριασμού DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λογαριασμός DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Ασφαλείας"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποσύνδεση"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρικός Λογαριασμός"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Εταιρείας"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχείρισης"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση λογαριασμών DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ανάπτυξης"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομική αποκάλυψη"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προστασία Δεδομένων"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δικαιοδοσία - Γλώσσα"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν έχει ανατεθεί εταιρεία. Προσθέστε μια εταιρεία."])}
          }
        }
      },
      "he-IL": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חשבון DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חשבון DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות אבטחה"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["להתנתק"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות שילוב"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חשבון תאגידי"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חברה"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות ניהול"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול חשבון החברה"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול חשבונות DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות פיתוח"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הודעות יוצאות"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["דוח תרגום"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["DutyPay GmbH - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - 2013 ©"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תנאי שימוש"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["גילוי משפטי"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגנת מידע"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיפוט - שפה"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין חברה שהוקצתה. אנא הוסף חברה."])}
          }
        }
      },
      "ga-IE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuntais DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuntas DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Slándála"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logáil amach"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe comhtháthaithe"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuntas Corparáideach"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuideachta"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Riaracháin"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riarachán cuntas cuideachta"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riaradh Cuntas DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Forbartha"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teachtaireachtaí Amach"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuarascáil aistriúcháin"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téarmaí Úsáide"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nochtadh dlíthiúil"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosaint Sonraí"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dlínse - Teanga"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon chuideachta sannta. Cuir cuideachta le do thoil."])}
          }
        }
      },
      "ja-JP": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPayアカウント設定"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay 口座"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セキュリティ設定"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログアウト"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統合設定"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業アカウント"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社の設定"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理設定"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業アカウント管理"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay アカウント管理"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開発設定"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信メッセージ"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻訳レポート"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用規約"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法的開示"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["データ保護"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管轄権-言語"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["割り当てられた会社はありません。 会社を追加してください。"])}
          }
        }
      },
      "hr-HR": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke DutyPay Računa"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Račun"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne Postavke"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjavite se"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporativni Račun"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Tvrtke"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administracije"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa tvrtke"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija DutyPay računa"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke razvoja"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prijevodu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uvjeti korištenja"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravna objava"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaštita Podataka"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nadležnost - Jezik"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema dodijeljene tvrtke. Molimo dodajte tvrtku."])}
          }
        }
      },
      "lv-LV": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konta Iestatījumi"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konts"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drošības Iestatījumi"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atteikties"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrācijas iestatījumi"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korporatīvais Konts"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma Lestatījumi"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrēšanas iestatījumi"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma konta administrēšana"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay kontu administrēšana"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izstrādes iestatījumi"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izejošie ziņojumi"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tulkošanas ziņojums"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietošanas noteikumi"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiska izpaušana"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datu Aizsardzība"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdikcija - Valoda"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav norīkota uzņēmuma. Lūdzu, pievienojiet uzņēmumu."])}
          }
        }
      },
      "lt-LT": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Paskyros Nustatymai"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Sąskaita"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apsaugos Nustatymai"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atsijungti"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integravimo parametrai"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės Sąskaita"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės Nustatymai"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administravimo nustatymai"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės sąskaitos administravimas"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay sąskaitų administravimas"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kūrimo nustatymai"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išeinantys pranešimai"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertimo ataskaita"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naudojimo sąlygos"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teisinis atskleidimas"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duomenų Apsauga"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdikcija - Kalba"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra paskirtos įmonės. Pridėkite įmonę."])}
          }
        }
      },
      "pt-PT": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Conta DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições de Segurança"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sair"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de integração"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta Corporativa"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Empresa"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de administração"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração de contas corporativas"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração de Contas DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de desenvolvimento"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensagens de Saída"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relatório de tradução"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termos de uso"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgação Legal"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proteção de Dados"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdição - Idioma"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nenhuma empresa atribuída. Adicione uma empresa."])}
          }
        }
      },
      "ro-RO": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setările Contului DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cont DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de Securitate"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deconectare"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de integrare"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cont Corporativ"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări Companie"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de administrare"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea contului companiei"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea conturilor DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de dezvoltare"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport de traducere"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Întreprindere"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termeni de utilizare"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgarea legală"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protejarea Datelor"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdicție - Limbă"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicio companie desemnată. Vă rugăm să adăugați o companie."])}
          }
        }
      },
      "ru-RU": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки учетной записи DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аккаунт DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки Безопасности"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выход"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки интеграции"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Корпоративный Счет"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки Kомпании"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки администрирования"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Управление корпоративным аккаунтом"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация счетов DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки разработки"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящие сообщения"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отчет о переводе"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия эксплуатации"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Юридическое раскрытие"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Защита Данных"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Юрисдикция - Язык"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет назначенной компании. Пожалуйста, добавьте компанию."])}
          }
        }
      },
      "sv-SE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoinställningar"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Konto"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Säkerhetsinställningar"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logga ut"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsinställningar"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagskonto"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinställningar"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrationsinställningar"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration av företagskonton"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay kontoadministration"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utvecklingsinställningar"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utgående meddelanden"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Översättningsrapport"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Villkor"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laglig information"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dataskydd"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behörighet - Språk"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inget tilldelat företag. Lägg till ett företag."])}
          }
        }
      },
      "sk-SK": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Účtu DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostné Nastavenia"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlásiť sa"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia integrácie"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firemný Účet"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Spoločnosti"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia správy"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemného účtu"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa účtov DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia vývoja"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchádzajúce správy"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa o preklade"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmienky používania"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Právne sprístupnenie"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrana Dát"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdikcia - Jazyk"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadna pridelená spoločnosť. Pridajte spoločnosť."])}
          }
        }
      },
      "cs-CZ": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Účtu DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostní Nastavení"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlásit se"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení integrace"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firemní Účet"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Společnosti"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení administrace"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemního účtu"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa účtů DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení vývoje"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchozí zprávy"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpráva o překladu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Společnost"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmínky použití"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Právní zveřejnění"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ochrana Dat"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jurisdikce - Jazyk"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná přiřazená společnost. Přidejte společnost."])}
          }
        }
      },
      "tr-TR": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Ayarları"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesabı"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik Ayarları"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış Yap"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurumsal Hesap"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetim Ayarları"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Yönetimi"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirme Ayarları"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal açıklama"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri Koruması"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yargı - Dil"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirket yok. Lütfen bir şirket ekleyin."])}
          }
        }
      },
      "hu-HU": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Fiókbeállítások"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Számla"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biztonsági Beállítások"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kijelentkezés"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrációs beállítások"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati Számla"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati Beállítások"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adminisztrációs beállítások"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati számla adminisztráció"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay számlák adminisztrációja"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejlesztési beállítások"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimenő üzenetek"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fordítási jelentés"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Használati feltételek"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jogi közzététel"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adat Védelem"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Joghatóság - Nyelv"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs kijelölt vállalat. Kérjük, adjon hozzá egy vállalatot."])}
          }
        }
      },
      "fr-BE": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les Paramètres de Sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'Entreprise"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'administration"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration des comptes DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de développement"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgation légale"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des Données"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiction - Langue"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        }
      },
      "fr-LU": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les Paramètres de Sécurité"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte d'Entreprise"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'Entreprise"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'administration"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration des comptes DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de développement"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d'utilisation"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Divulgation légale"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protection des Données"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiction - Langue"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune entreprise assignée. Veuillez ajouter une entreprise."])}
          }
        }
      },
      "mt-MT": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Kont DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kont DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tas-Sigurtà"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oħroġ"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-integrazzjoni"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kont Korporattiv"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Kumpanija"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings ta' Amministrazzjoni"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ġestjoni tal-Kont Korporattiv"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazzjoni tal-Kontijiet DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings ta' żvilupp"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaġġ li joħroġ"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport tat-traduzzjoni"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termini ta 'Użu"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żvelar Legali"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Protezzjoni tad-Dejta"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ġurisdizzjoni - Lingwa"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda kumpanija assenjata. Jekk jogħġbok żid kumpanija."])}
          }
        }
      },
      "sl-SI": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve Računa DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Račun DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varnostne Nastavitve"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odjava"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve integracije"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Račun Podjetja"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve Podjetja"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve administracije"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa podjetja"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upravljanje računov DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razvojne nastavitve"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhodna sporočila"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poročilo o prevodu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podjetje"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogoji uporabe"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravno razkritje"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varstvo Podatkov"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pristojnost - Jezik"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni dodeljenega podjetja. Dodajte podjetje."])}
          }
        }
      },
      "el-CY": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Λογαριασμού DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λογαριασμός DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Ασφαλείας"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποσύνδεση"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρικός Λογαριασμός"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Εταιρείας"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχείρισης"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση λογαριασμών DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ανάπτυξης"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομική αποκάλυψη"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προστασία Δεδομένων"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δικαιοδοσία - Γλώσσα"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν έχει ανατεθεί εταιρεία. Προσθέστε μια εταιρεία."])}
          }
        }
      },
      "tr-CY": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Ayarları"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesabı"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik Ayarları"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çıkış Yap"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurumsal Hesap"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetim Ayarları"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Yönetimi"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirme Ayarları"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal açıklama"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri Koruması"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yargı - Dil"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirket yok. Lütfen bir şirket ekleyin."])}
          }
        }
      },
      "uk-UA": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Облікового Запису DutyPay"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок DutyPay"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Параметри Безпеки"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Інтеграції"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок Kомпанії"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Kомпанії"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування адміністрування"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Управління корпоративним рахунком"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адміністрування рахунків DutyPay"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування розробки"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підприємство"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["відбиток"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Захист Даних"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein zugewiesenes Unternehmen. Bitte fügen Sie ein Unternehmen hinzu."])}
          }
        }
      },
      "zh-CN": {
        "accountSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay 账户设置"])},
          "accountInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay 帐户"])}
          },
          "securitySettings": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["安全设定"])}
          },
          "logout": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登出"])}
          }
        },
        "companySettings": {
          "integrations": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集成设置"])}
          },
          "companyInformation": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企业账户"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司设定"])}
        },
        "adminSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理设置"])},
          "companyAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司账户管理"])}
          },
          "userAdministration": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay 账户管理"])}
          }
        },
        "developerSettings": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开发设置"])},
          "translationEmailReportOverview": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外发邮件"])}
          },
          "translationReport": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻译报告"])}
          }
        },
        "copyrightNotice": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["© 2013 - ", _interpolate(_named("currentDateDisplayOnlyYear")), " - DutyPay GmbH"])}
        },
        "company": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])}
        },
        "legalLinks": {
          "termsAndConditions": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用条款"])}
          },
          "imprint": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法律披露"])}
          },
          "privacyPolicy": {
            "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据保护"])}
          }
        },
        "languages": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["辖区-语言"])}
        },
        "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "feedforward": {
          "noCompany": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有指定的公司。 请添加公司。"])}
          }
        }
      }
    }
  })
}
